import { Component, ElementRef, Input, ViewChild } from '@angular/core'
import { HubtypeBotConfig } from '../../models/hubtype-bot-config'
import { HubtypeProviderAccount } from '../../models/hubtype-provider-account'
import { AngularComponent } from '../AngularComponent'

@Component({
  selector: 'app-webchat-snippet',
  templateUrl: './webchat-snippet.component.html',
  styleUrls: ['./webchat-snippet.component.scss'],
  standalone: false,
})
export class WebchatSnippetComponent extends AngularComponent {
  @Input() providerAccount: HubtypeProviderAccount
  @Input() showCodeSnippet = false
  @Input() botConfig: HubtypeBotConfig | null = null
  @ViewChild('webchatSnippet', { static: false })
  private snippetContent: ElementRef<HTMLParagraphElement>

  constructor() {
    super()
  }

  injectBotonicSdk() {
    if (this.botConfig?.isBotonicV2OrHigher) {
      return this.injectBotonicV2Sdk()
    }
    return this.injectBotonicV1Sdk()
  }

  private injectBotonicV1Sdk() {
    const webchatSDK = `<html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <script
        type="text/javascript"
        src="${this.providerAccount.netlify_url}/webchat.botonic.js"
      ></script>
    </head>
    <body>
      <div id="root" />
      <script type="text/javascript">
        document.addEventListener('DOMContentLoaded', function (event) {
          Botonic.render(document.getElementById('root'), {
            appId: '${this.providerAccount.id}',
            // visibility: 'dynamic', // Uncomment for enable dynamic settings (Botonic +0.12.0).
          })
        })
      </script>
    </body>
    </html>`
    return webchatSDK
  }

  private injectBotonicV2Sdk() {
    const webchatSDK = `<html lang="en">
  <head>
    <meta charset="utf-8" />
    <title>Botonic Webchat</title>
    <base href="/" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <link rel="icon" type="image/x-icon" href="/favicon.ico" />
    <link
      rel="stylesheet"
      href="${this.providerAccount.netlify_url}/webchat/webchat.botonic.css"
    />
  </head>
  <body>
    <div id="root"></div>
    <script
      type="module"
      src="${this.providerAccount.netlify_url}/webchat/webchat.botonic.js"
    ></script>
    <script type="text/javascript">
      document.addEventListener('DOMContentLoaded', function (event) {
        botonic.render(document.getElementById('root'), {
          appId: '${this.providerAccount.id}',
        })
      })
    </script>
  </body>
</html>`
    return webchatSDK
  }

  copyToClipboard() {
    const content = this.snippetContent.nativeElement.innerText
    navigator.clipboard.writeText(content)
  }

  toggleCodeSnippet() {
    this.showCodeSnippet = !this.showCodeSnippet
  }
}
